import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  SUSPICIOUS_USER_MUST_CONFIRM: null,
  NEEDS_LOGIN_LINK: null
});